import { RootState } from '~/store';

export const selectShowComposer = (state: RootState) =>
  state?.composerPopover?.showComposer;
